import { render, staticRenderFns } from "./UserRight.vue?vue&type=template&id=b3f21008&"
import script from "./UserRight.vue?vue&type=script&lang=js&"
export * from "./UserRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports